
import React from 'react';
import { ArrowRight } from 'lucide-react';

const WorkflowSection = () => {
  const steps = [
    {
      id: 1,
      title: 'Candidates submit resume',
      description: 'Talented candidates submit their resumes through our platform'
    }, 
    {
      id: 2,
      title: 'Recruiters find relevant candidates',
      description: 'Recruiters post jobs and find candidates with matching skillsets'
    }, 
    {
      id: 3,
      title: 'Candidates are interviewed',
      description: 'Qualified candidates go through the interview process'
    }, 
    {
      id: 4,
      title: 'Candidates fulfill roles & establish SOP',
      description: 'Selected candidates start working and establish standard operating procedures'
    }, 
    {
      id: 5,
      title: 'AI automates SOP',
      description: 'AI learns and automates standard tasks, reducing long-term costs'
    }, 
    {
      id: 6,
      title: 'Candidates move to other projects',
      description: 'Human talent focuses on new challenges while AI handles routine tasks'
    }
  ];
  
  return (
    <section className="py-20 bg-gradient-to-br from-[#F0F9FF] via-[#E0F2FE] to-[#DBEAFE]">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16 tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-[#0EA5E9] to-[#6366F1]">
          How Talento AI Works
        </h2>
        
        <div className="max-w-4xl mx-auto space-y-12">
          {steps.map((step, index) => (
            <div key={step.id} className="flex items-start space-x-6">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-[#0EA5E9] to-[#3B82F6] text-white flex items-center justify-center font-bold shadow-md">
                  {step.id}
                </div>
                {index < steps.length - 1 && (
                  <div className="h-10 w-px bg-gradient-to-b from-[#0EA5E9] to-[#3B82F6] mx-auto my-2"></div>
                )}
              </div>
              
              <div className="pt-1">
                <h3 className="text-xl font-semibold text-[#0EA5E9] mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
